import { Business as BusinessIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import { Link } from "react-router-dom";
import { Avatar } from "../../../commons/Avatar.js";
import { ProfileListItemButton } from "../../../commons/ProfileListItem.js";
import { getAddressLabel } from "../../addresses/helpers.js";
import { BuildingRow__BuildingFragment } from "../Buildings.generated.js";

interface Props {
  building: BuildingRow__BuildingFragment;
  divider?: boolean;
}

const BuildingRow = ({ building, divider = true }: Props) => {
  const { t } = useTranslate("BuildingRow");
  return (
    <ProfileListItemButton
      avatar={<Avatar size="m" icon={<BusinessIcon />} type="square" />}
      primary={building.title}
      secondary={
        building.buildingAddress
          ? getAddressLabel(building.buildingAddress)
          : t("Address not set")
      }
      listItemProps={{
        divider,
        component: Link,
        to: `/buildings/${building.id}`,
      }}
    />
  );
};

export default BuildingRow;
